import { ref } from 'vue'

export function getCurrencyList() {
    const currencyList = ref([
        { code: "USD", name: "United States Dollar" },
        { code: "EUR", name: "Euro" },
        { code: "JPY", name: "Japanese Yen" },
        { code: "GBP", name: "British Pound Sterling" },
        { code: "AUD", name: "Australian Dollar" },
        { code: "CAD", name: "Canadian Dollar" },
        { code: "CHF", name: "Swiss Franc" },
        { code: "CNY", name: "Chinese Yuan" },
        { code: "SEK", name: "Swedish Krona" },
        { code: "NZD", name: "New Zealand Dollar" },
        { code: "MXN", name: "Mexican Peso" },
        { code: "SGD", name: "Singapore Dollar" },
        { code: "HKD", name: "Hong Kong Dollar" },
        { code: "NOK", name: "Norwegian Krone" },
        { code: "KRW", name: "South Korean Won" },
        { code: "TRY", name: "Turkish Lira" },
        { code: "INR", name: "Indian Rupee" },
        { code: "RUB", name: "Russian Ruble" },
        { code: "BRL", name: "Brazilian Real" },
        { code: "ZAR", name: "South African Rand" },
        { code: "TTD", name: "Trinidad & Tobago Dollar" },
        { code: "XCD", name: "EC Dollar" }, 
        { code: "BBD", name: "Barbados Dollar" }, 
        { code: "CNY", name: "China Renminbi" }, 
        { code: "AED", name: "UAE Dirham" },
        { code: "EGP", name: "Egyptian Pound" }, 
        { code: "GYD", name: "Guyana Dollar" }, 
        { code: "BZD", name: "Belize Dollar" },
    ])

    return currencyList
}